import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwj30aApi, QueryParams, PrintPreviewResult } from '../../../services/pwj30aApi';

export function usePWJ30AQuery() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<PrintPreviewResult | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runBuildPrint = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwj30aApi.buildPrint(params);
      if (resp.records && resp.records.length > 0) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(null);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('建立列印資料失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runBuildPrint, reset };
}
